module.exports = __webpack_public_path__ + "img/btn-logout-en.e1365f57.png";